import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Regemp from "./pages/register/employeeRegistrationForm";
import JobDetail from "./pages/JobDetail";
import Login from "./pages/login/login";
import Dashboard from "./pages/dashboard";
import Comdashboard from "./pages/compdash";
import CompanyRegistration from "./pages/company/companyregisterform";
import CompanyDetails from "./pages/company/CompanyDetailsForm";
import CompanyInformation from "./pages/company/ProductsAndServicesForm";
import AddEmployee from "./pages/company/AddEmployees";
import AdminHome from "./pages/JobkitCompany/AdminHome";
import ManagerHome from "./pages/JobkitCompany/ManagerHome";
import TelecallerHome from "./pages/JobkitCompany/TelecallerHome";
import Profile from "./pages/JobkitCompany/Profile";
import Edit_Profile from "./pages/JobkitCompany/EditProfile";
import AddProfileDetails from "./pages/JobkitCompany/AddProfileDetails";
import DocumentManagerHome from "./pages/Document/DocumentManagerHome";
import NewCompaniesManager from "./pages/Document/NewCompanies";
import DocumentTelecallerHome from "./pages/Document/DocumentTelecallerHome";
import NewDocumentsEmployee from "./pages/Document/NewDocuments";
import EducationForm from "./pages/register/EducationDetails";
import ProfessionalDetails from "./pages/register/ProfessionalDetails";
import UnemployedHome from "./pages/Unemployed/UnemployedHome";
import NewUnemployed from "./pages/JobkitCompany/NewUnemployed";
import EmployeeHome from "./pages/Employees/EmployeeHome";
import AddProducts from "./pages/company/AddProducts";
import NewProductsPage from "./pages/JobkitCompany/NewProducts";
import NewProductsTelecaller from "./pages/JobkitCompany/NewProductsTelecaller";
import AllProducts from "./pages/JobkitCompany/AllProducts";
import CompanyHighlight from "./pages/company/CompanyHighlight";
import ProductHighlight from "./pages/company/ProductHighlight";
import CompanyHighlightRequest from "./pages/JobkitCompany/CompanyHighlightRequest";
import ProductHighlightRequests from "./pages/JobkitCompany/ProductHighlightRequest";
import Company_Highlight_Telecaller from "./pages/JobkitCompany/CompanyHighlightTelecaller";
import ProductHighlightTelecaller from "./pages/JobkitCompany/ProductHighlightTelecaller";
import ResignationRequest from "./pages/Employees/ResignationRequest";
import ResignationRequestsCompany from "./pages/company/ResignationRequests";
import AddJobsPage from "./pages/company/AddJobs";
import ViewJobs from "./pages/company/ViewJobs";
import EditJobsPage from "./pages/company/EditJobs";
import AllJobsPage from "./pages/JobkitCompany/AllJobs";
import AllCompaniesPage from "./pages/JobkitCompany/AllCompanies";
import AllResignationRequests from "./pages/Employees/AllResignationRequests";

import JobStreamChangeForm from "./pages/JobkitCompany/JobStreamChangeForm";
import JobstreamChangeRequests from "./pages/JobkitCompany/JobStreamChangeRequests";
import AssignedRequests from "./pages/JobkitCompany/AssignedRequests";
import BlacklistForm from "./pages/JobkitCompany/BlacklistForm";
import ManagerBlacklist from "./pages/JobkitCompany/ManagerBlacklist";
import AssignedBlacklistRequests from "./pages/JobkitCompany/AssignedBlacklistRequests";
import ManagerBlacklistRequests from "./pages/JobkitCompany/ManagerBlacklistRequests";
import AddCertificate from "./pages/JobkitCompany/AddCertificate";
import CertificateRequests from "./pages/Document/CertificateRequests";
import TelecallerCertificateRequests from "./pages/Document/TelecallerCertificateRequests";

import ManagerSuggestion from "./pages/JobkitCompany/ManagerSuggestion";
import Socialworker_home from "./pages/JobkitCompany/Socialworker_home";
import TelecallerSuggestion from "./pages/JobkitCompany/TelecallerSuggestion";
import SocialworkerSuggestion from "./pages/JobkitCompany/SocialworkerSuggestion";
import CounsellorSuggestion from "./pages/JobkitCompany/CounsellorSuggestion";
import UnemployedSuggestion from "./pages/Unemployed/UnemployedSuggestion";

import ProductAdsRequestPage from "./pages/company/ProductAdsRequest";
import CompanyAdsRequestsView from "./pages/company/CompanyAdsRequests";
import NewAdsRequests from "./pages/JobkitCompany/NewAdsRequests";
import AdsRequestTelecaller from "./pages/JobkitCompany/AdsRequestTelecaller";
import TechnicalSupportEmployee from "./pages/Employees/TechnicalSupport";
import TechnicalSupportRequests from "./pages/JobkitCompany/TechnicalSupportRequests";
import AllProductsEmployee from "./pages/Employees/AllProductsEmployee";
import AllJobsEmployeePage from "./pages/Employees/AllJobsEmployee";
import CompanyOwnProducts from "./pages/company/CompanyOwnProducts";
import OtherCompanyProducts from "./pages/company/OtherCompanyProducts";
import LendEmployeesPage from "./pages/company/LendEmployees";
import LendEmployeesRequestsCompany from "./pages/company/LendEmployeeRequests";
import EmployeeLendingRequestsPage from "./pages/JobkitCompany/EmployeeLendingRequests";
import RequestEmployeesCompanyPage from "./pages/company/RequestEmployees";
import EmployeesNeededRequests from "./pages/JobkitCompany/EmployeesNeededRequests";
import TargetAudiencePage from "./pages/company/TargetAudienceProduct";
import TargetAudienceRequests from "./pages/company/TargetAudienceRequests";
import TargetAudiencePageAdmin from "./pages/JobkitCompany/TargetAudienceRequestsAssign";
import TargetAudiencePageTelecaller from "./pages/JobkitCompany/TargetAudienceTelecaller";

import Ratingfactors from "./pages/company/ratingfactors";
import Addrating from "./pages/company/add_rating";
import Workassaign from "./pages/company/work_assign";
import Showrating from "./pages/Employees/show_rating";
import Showwork from "./pages/Employees/show_work";

import ViewEmployeeDetails from "./pages/JobkitCompany/ViewEmployeeDetails";
import ViewEmployees from "./pages/company/ViewEmployees";
import PremiumMembershipEmployee from "./pages/Employees/PremiumMembershipEmployee";
import PremiumMembershipCompany from "./pages/company/PremiumMembershipCompany";
import PremiumMembershipManagerEmployee from "./pages/JobkitCompany/PremiumMembershipManagerEmployee";
import PremiumMembershipManagerCompany from "./pages/JobkitCompany/PremiumMembershipManagerCompany";
import MembershipCompany from "./pages/JobkitCompany/MembershipCompany";
import MembershipEmployee from "./pages/JobkitCompany/MembershipEmployee";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/comdashboard" element={<Comdashboard />} />
          <Route path="/job/:id" element={<JobDetail />} />
          <Route
            path="/company_registration"
            element={<CompanyRegistration />}
          />
          <Route path="/company_details" element={<CompanyDetails />} />
          <Route path="/company_information" element={<CompanyInformation />} />
          <Route path="/add_employees" element={<AddEmployee />} />
          <Route path="/admin_home" element={<AdminHome />} />
          <Route path="/manager_home" element={<ManagerHome />} />
          <Route path="/telecaller_home" element={<TelecallerHome />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/edit_profile" element={<Edit_Profile />} />
          <Route path="/add_profile_details" element={<AddProfileDetails />} />
          <Route
            path="/document_manager_home"
            element={<DocumentManagerHome />}
          />
          <Route
            path="/new_companies_manager"
            element={<NewCompaniesManager />}
          />
          <Route
            path="/document_tele_home"
            element={<DocumentTelecallerHome />}
          />
          <Route
            path="/new_documents_employee"
            element={<NewDocumentsEmployee />}
          />
          <Route path="/regemp" element={<Regemp />} />
          <Route path="/education_page" element={<EducationForm />} />
          <Route
            path="/professional_details"
            element={<ProfessionalDetails />}
          />
          <Route path="/unemployed_home" element={<UnemployedHome />} />
          <Route path="/new_unemployed" element={<NewUnemployed />} />
          <Route path="/employee_home_page" element={<EmployeeHome />} />
          <Route path="/add_products" element={<AddProducts />} />
          <Route path="/new_products_page" element={<NewProductsPage />} />
          <Route
            path="/new_products_telecaller"
            element={<NewProductsTelecaller />}
          />
          <Route path="/all_products" element={<AllProducts />} />
          <Route path="/company_highlight" element={<CompanyHighlight />} />
          <Route path="/product_highlight" element={<ProductHighlight />} />
          <Route
            path="/company_highlight_request_manager"
            element={<CompanyHighlightRequest />}
          />
          <Route
            path="/product_highlight_request_manager"
            element={<ProductHighlightRequests />}
          />
          <Route
            path="/company_highlight_request_telecaller"
            element={<Company_Highlight_Telecaller />}
          />
          <Route
            path="/product_highligth_request_telecaller"
            element={<ProductHighlightTelecaller />}
          />
          <Route
            path="/resignation_request_employee"
            element={<ResignationRequest />}
          />
          <Route
            path="/resignation_requests_company"
            element={<ResignationRequestsCompany />}
          />
          <Route path="/add_jobs_page" element={<AddJobsPage />} />
          <Route path="/view_jobs_company" element={<ViewJobs />} />
          <Route path="/edit_jobs_company/:id/" element={<EditJobsPage />} />
          <Route path="/all_jobs_page" element={<AllJobsPage />} />
          <Route path="/all_companies_page" element={<AllCompaniesPage />} />
          <Route
            path="/all_resignation_requests_employee"
            element={<AllResignationRequests />}
          />

          <Route path="/change-request" element={<JobStreamChangeForm />} />
          <Route
            path="/manager-change-requests"
            element={<JobstreamChangeRequests />}
          />
          <Route
            path="/telecaller-assigned-requests"
            element={<AssignedRequests />}
          />
          <Route path="/blacklistform" element={<BlacklistForm />} />
          <Route path="/blacklist-requests" element={<ManagerBlacklist />} />
          <Route
            path="/telecaller-assigned-blacklist-requests"
            element={<AssignedBlacklistRequests />}
          />
          <Route
            path="/further-blacklist-requests"
            element={<ManagerBlacklistRequests />}
          />
          <Route path="/add-certificate" element={<AddCertificate />} />
          <Route
            path="/document-manager-certificate"
            element={<CertificateRequests />}
          />
          <Route
            path="/document-telecaller-certificate"
            element={<TelecallerCertificateRequests />}
          />

          <Route path="/managersuggestion" element={<ManagerSuggestion />} />
          <Route path="/socialworker_home" element={<Socialworker_home />} />
          <Route
            path="/telecallersuggestion"
            element={<TelecallerSuggestion />}
          />
          <Route
            path="/socialworkersuggestion"
            element={<SocialworkerSuggestion />}
          />
          <Route
            path="/counsellorsuggestion"
            element={<CounsellorSuggestion />}
          />
          <Route
            path="/unemployedsuggestion"
            element={<UnemployedSuggestion />}
          />

          <Route
            path="/product_ads_page_company"
            element={<ProductAdsRequestPage />}
          />
          <Route
            path="/all_ads_company_page"
            element={<CompanyAdsRequestsView />}
          />
          <Route path="/new_ads_requests" element={<NewAdsRequests />} />
          <Route
            path="/ads_request_telecaller"
            element={<AdsRequestTelecaller />}
          />
          <Route
            path="/technical_support_employee_page"
            element={<TechnicalSupportEmployee />}
          />
          <Route
            path="/technical_support_requests"
            element={<TechnicalSupportRequests />}
          />
          <Route
            path="/all_products_employee"
            element={<AllProductsEmployee />}
          />
          <Route path="/all_jobs_employee" element={<AllJobsEmployeePage />} />
          <Route
            path="/company_own_products"
            element={<CompanyOwnProducts />}
          />
          <Route
            path="/other_company_products"
            element={<OtherCompanyProducts />}
          />
          <Route path="/lend_employees_page" element={<LendEmployeesPage />} />
          <Route
            path="/lend_employees_cmp_page"
            element={<LendEmployeesRequestsCompany />}
          />
          <Route
            path="/employee_lending_requests_page"
            element={<EmployeeLendingRequestsPage />}
          />
          <Route
            path="request_employees_page_company"
            element={<RequestEmployeesCompanyPage />}
          />
          <Route
            path="/employees_needed_requests_page"
            element={<EmployeesNeededRequests />}
          />
          <Route
            path="/target_audience_page"
            element={<TargetAudiencePage />}
          />
          <Route
            path="/target_audience_requests_cmp"
            element={<TargetAudienceRequests />}
          />
          <Route
            path="/target_audience_page_admin"
            element={<TargetAudiencePageAdmin />}
          />
          <Route
            path="/target_audience_page_telecaller"
            element={<TargetAudiencePageTelecaller />}
          />

          <Route path="/ratingfactors" element={<Ratingfactors />} />
          <Route path="/rating" element={<Addrating />} />
          <Route path="/workassign" element={<Workassaign />} />
          <Route path="/showrating" element={<Showrating />} />
          <Route path="/showwork" element={<Showwork />} />

          <Route path="/viewEmployees" element={<ViewEmployeeDetails />} />
          <Route path="/viewEmployeesCompany" element={<ViewEmployees />} />

          <Route
            path="/premiumMembershipEmployee"
            element={<PremiumMembershipEmployee />}
          />
          <Route
            path="/premiumMembershipCompany"
            element={<PremiumMembershipCompany />}
          />
          <Route
            path="/premiumMembershipManagerEmp"
            element={<PremiumMembershipManagerEmployee />}
          />
          <Route
            path="/premiumMembershipManageComp"
            element={<PremiumMembershipManagerCompany />}
          />
          <Route path="/membershipCompany" element={<MembershipCompany />} />
          <Route path="/membershipEmployee" element={<MembershipEmployee />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
